"use client"

import { StatusCell as StatusCellPrimitive } from "@exxatdesignux/ui/components/data-views/table-cells"
import type { StatusBadgeSemanticSize } from "@exxatdesignux/ui/components/ui/status-badge"
import type { ComponentProps } from "react"

/** Icon + label status chips use md density in tables and outside. */
export function StatusCell({
  size,
  icon,
  ...rest
}: ComponentProps<typeof StatusCellPrimitive>) {
  const resolvedSize: StatusBadgeSemanticSize = size ?? (icon ? "md" : "sm")
  return <StatusCellPrimitive {...rest} icon={icon} size={resolvedSize} />
}
